import _ from 'lodash';
import React from 'react';
import employmentTypes from '~/lookups/employment-types';
import MultiSelect from '../MultiSelect';

const options = _.values(employmentTypes);

export default function EmploymentTypeFilter({ placeholder = 'Member Type', name, value, onChange }) {
  return (
    <MultiSelect.Filter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.map((v) => v.name).join('; ')}
      options={options}
      onChange={onChange}
    />
  );
}
